/**
 * @generated SignedSource<<29d52e269d1d124d8e3b340cd4072449>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleSlug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsMapContributionsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsMapContributions_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionsMapContributionsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "themes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bookmarksCreationAuthorized",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "ContributionConnection",
                "kind": "LinkedField",
                "name": "contributions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Contribution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasLocation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isFromAdminUser",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Author",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "statusName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAdmin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "additionalViewerFields",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Viewer",
                                "abstractKey": "__isViewer"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "iconClass",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCommentsCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votesMode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "authorizations",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDownAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "commentsDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Votes",
                                "kind": "LinkedField",
                                "name": "votes",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "up",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "down",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": [
                  "filters"
                ],
                "handle": "connection",
                "key": "ContributionsList_contributions",
                "kind": "LinkedHandle",
                "name": "contributions"
              },
              (v11/*: any*/)
            ],
            "type": "ParticipativeModule",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25e30529028fa6231d0344758dd07ec6",
    "id": null,
    "metadata": {},
    "name": "ContributionsMapContributionsManagerQuery",
    "operationKind": "query",
    "text": "query ContributionsMapContributionsManagerQuery(\n  $participativeModuleSlug: ID!\n  $contributionsCount: Int!\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n) {\n  participativeModule(participativeModuleSlug: $participativeModuleSlug) {\n    __typename\n    ...ContributionsMapContributions_participativeModule\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionCard_contribution on Contribution {\n  id\n  title\n  hasLocation\n  isFromAdminUser\n  author {\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  themes {\n    ...ContributionThemesLabel_themes\n    id\n  }\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionThemesLabel_themes on Theme {\n  id\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n}\n\nfragment ContributionsListFilters_participativeModule on ParticipativeModule {\n  themes {\n    __typename\n    id\n  }\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n  ...ThemeFilter_participativeModule\n  ...BookmarkedFilter_participativeModule\n}\n\nfragment ContributionsMapContributionsFragment_participativeModule on ParticipativeModule {\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters) {\n    totalCount\n    edges {\n      node {\n        id\n        slug\n        ...ContributionCard_contribution\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ContributionsMapContributionsList_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsMapContributions_participativeModule on ParticipativeModule {\n  ...ContributionsListFilters_participativeModule\n  ...ContributionsMapContributionsFragment_participativeModule\n  ...ContributionsMapContributionsList_participativeModule\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment ThemeFilter_participativeModule on ParticipativeModule {\n  themes {\n    id\n    name\n    primaryColor\n    primaryContrastColor\n  }\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n"
  }
};
})();

node.hash = "f5e90cc24cd7fbd7158c6d33c9b4e295";

module.exports = node;
